<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <iframe id="stream" frameborder="0" style="width: 100%; height: 550px"></iframe>
                </div>
                <div class="col-md-8 margin-top-40">
                    <div class="col-md-12">
                        <div class="dash-inner-box">
                            <div class="dashboard-heading">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h1>Students Queries</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <ul id="queries-list" class="comments-list queries">
                                        <li v-for="cl in commentsList" v-if="commentsList" :id="cl.comment_enc_id">
                                            <div class="comment-main-level">
                                                <!-- Avatar -->
                                                <div class="comment-avatar">
                                                    <img :src="cl.image" alt="">
                                                </div>
                                                <!-- Contenedor del Comentario -->
                                                <div class="comment-box">
                                                    <div class="comment-head">
                                                        <h6 class="comment-name by-author">
                                                            <a href="javascript:;">
                                                                {{cl.name}}
                                                            </a>
                                                        </h6>
                                                        <span class="posted-time">Posted on 10-FEB-2015 12:00</span>
                                                    </div>
                                                    <div class="comment-content">
                                                        {{cl.comment}}
                                                        <div class="comment-open">
                                                            <a class="btn-reply">
                                                                Reply
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="comment-footer">
                                                        <div class="comment-form">
                                                            <textarea class="form-control" name=""></textarea>
                                                            <div class="pull-right send-button">
                                                                <a class="btn-send send-reply">Send</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul class="comments-list queries reply-list">
                                                <li v-if="cl.hasChild" v-for="rl in cl.onlineClassComments">
                                                    <div class="comment-avatar">
                                                        <img :src="rl.image" alt="">
                                                    </div>
                                                    <div class="comment-box">
                                                        <div class="comment-head">
                                                            <h6 class="comment-name"><a
                                                                    href="javascript:;">{{rl.name}}</a>
                                                            </h6>
                                                            <span class="posted-time">Posted on DD-MM-YYYY HH:MM</span>
                                                        </div>
                                                        <div class="comment-content">
                                                            {{rl.comment}}
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-12">
                                    <div class="question-form">
                                        <textarea class="form-control" id="query-field"></textarea>
                                        <div class="pull-right send-button">
                                            <a class="btn-send" @click="sendQueries()" href="javascript:;">Send</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 margin-top-40">
                        <div class="dash-inner-box">
                            <div class="dashboard-heading">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h1>Discussion</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <ul id="comments-list-main" class="comments-list comments-main">

                                    </ul>
                                </div>
                                <div class="col-md-12" v-if="individualCommenting == true">
                                    <div class="question-form">
                                        <textarea class="form-control" id="comment-field"></textarea>
                                        <div class="pull-right send-button">
                                            <a class="btn-send" @click="sendQueries(true)" href="javascript:;">Send</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 margin-top-40">
                    <ul id="notes-list">
                        <li>Notes List</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import toastr from '../../../public/js/toastr.js';
    import firebase from 'firebase';
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        components: {
            // collegeBanner
        },
        data() {
            return {
                specialKey: 'BnE3860mWdnBEZMLXlwkdjw9A2K5DJ',
                db: firebase.database(),
                ref: '',
                classId: '',
                individualCommenting: false,
                commentsList: [],
                monthDict: {
                    0: 'Jan',
                    1: 'Feb',
                    2: 'Mar',
                    3: 'Apr',
                    4: 'May',
                    5: 'June',
                    6: 'July',
                    7: 'Aug',
                    8: 'Sep',
                    9: 'Oct',
                    10: 'Nov',
                    11: 'Dec',
                },
            }
        },
        mounted() {
            var t = this;
            showLoader();

            function getUrlVars() {
                var vars = {};
                var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                    vars[key] = value;
                });
                return vars;
            }

            t.classId = getUrlVars()["cid"];
            var user = this.$store.getters.getUser;
            var url = this.$store.getters.getDomain;
            var db = firebase.database();
            var ref = db.ref(t.specialKey + '/comments/' + t.classId);
            ref.on('value', gotData, errData);

            function gotData(data) {
                var result2 = [];
                for (var i in data.val()) {
                    result2.push([i, data.val()[i]]);
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        if (result2[z][1].reply_to == "" && result2[z][1].sender == t.$store.getters.getUser['user_id'] || result2[z][1].is_public == true) {
                            t.showComment(result2[z][1].is_public, result2[z][0], result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    } else {
                        if (result2[z][1].reply_to == "" && result2[z][1].sender == t.$store.getters.getUser['user_id']) {
                            var el = document.getElementById(result2[z][0]);
                            var data_key = el.getAttribute('data-key');
                            if (result2[z][1].is_public == true && data_key != result2[z][0]) {
                                document.getElementById(result2[z][0]).remove();
                                t.showComment(result2[z][1].is_public, result2[z][0], result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                            }
                        }
                    }
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0]) && document.getElementById(result2[z][1].reply_to)) {
                        if (result2[z][1].reply_to != "") {
                            t.showReply(result2[z][0], result2[z][1].reply_to, result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    }
                }
                // var data = data.val();
                // var keys = Object.keys(data);
            }

            function errData(data) {
                console.log('err');
            }

            var ref = db.ref(t.specialKey + '/notes/' + t.classId);
            ref.on('value', gotData1, errData1);

            function gotData1(data) {
                var result2 = [];
                for (var i in data.val()) {
                    result2.push([i, data.val()[i]]);
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        t.showNotes(result2[z][0], result2[z][1].name, result2[z][1].file);
                    }
                }
            }

            function errData1(data) {
                console.log('err');
            }

            var id = getUrlVars()["id"];
            if (this.$store.getters.getUserType == 'Individual' && id != "" && t.classId != '') {
                document.getElementById("stream").src = "https://sneh.eygb.me/live-stream/view/" + id;
                setTimeout(function () {
                    hideLoader();
                }, 1500)
            } else {
                this.$router.push({path: '/dashboard'})
            }
            $('#queries-list').perfectScrollbar();
            $('#comments-list-main').perfectScrollbar();
            t.initializeEvents();
        },
        methods: {
            sendQueries(visibility = false) {
                var t = this;
                var currentDate = new Date();
                var senddate = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
                var getMins = currentDate.getMinutes();
                if (getMins < 10) {
                    getMins = "0" + getMins;
                }
                var sendtime = currentDate.getHours() + ":" + getMins;
                if (visibility) {
                    var ques = document.getElementById('comment-field').value;
                } else {
                    var ques = document.getElementById('query-field').value;
                }
                if (ques != '') {
                    var uId = t.uniqueId();
                    var name = this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name'];
                    var image = this.$store.getters.getUser['image'];
                    var ref = t.db.ref(this.specialKey + '/comments/' + t.classId + '/' + uId);
                    ref.set({
                        'name': name,
                        'sender': t.$store.getters.getUser['user_id'],
                        'is_public': visibility,
                        'reply_to': "",
                        'comment': ques,
                        'image': image,
                        'date': senddate,
                        'time': sendtime
                    });
                    t.saveComment(uId, ques);
                    if (visibility) {
                        document.getElementById('comment-field').value = "";
                    } else {
                        document.getElementById('query-field').value = "";
                    }
                } else {
                    alert('Enter Question to send');
                }
            },
            sendReply(message, id) {
                var t = this;
                var uId = t.uniqueId();
                var currentDate = new Date();
                var senddate = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
                var getMins = currentDate.getMinutes();
                if (getMins < 10) {
                    getMins = "0" + getMins;
                }
                var sendtime = currentDate.getHours() + ":" + getMins;
                var name = this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name'];
                var image = this.$store.getters.getUser['image'];
                var ref = t.db.ref(this.specialKey + '/comments/' + t.classId + '/' + uId);
                ref.set({
                    'name': name,
                    'sender': t.$store.getters.getUser['user_id'],
                    'reply_to': id,
                    'comment': message,
                    'image': image,
                    'date': senddate,
                    'time': sendtime,
                });
                t.saveComment(uId, message, id);
            },
            saveComment(id, question, reply_to = null) {
                var t = this;
                var url = this.$store.getters.getDomain;

                var data = {'id': id, 'class_id': t.classId, 'comment': question}
                if (reply_to) {
                    data['reply_to'] = reply_to;
                }
                axios.post(`${url}api/v2/classes/save-comment`, data, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        toastr.success('Query Send', 'Success');
                    } else {
                        toastr.error('An Error Occurred Try Again', 'Oops!!');
                    }
                });
            },
            showComment(visibility, id, name, message, date, image) {
                if (visibility) {
                    var template = '<li id="' + id + '" data-key="' + id + '"><div class="comment-main-level"><div class="comment-avatar"><img src="' + image + '" alt=""></div><div class="comment-box"><div class="comment-head"><h6 class="comment-name"><a href="#">' + name + '</a></h6><span class="posted-time">Posted on ' + date + '</span></div><div class="comment-content">' + message + '<div class="comment-open"><a class="btn-reply">Reply</a></div></div><div class="comment-footer"><div class="comment-form"><textarea class="form-control" name=""></textarea><div class="pull-right send-button"><a class="btn-send send-reply">Send</a></div></div></div></div></div><ul class="comments-list queries reply-list"></ul></li>';
                    document.getElementById('comments-list-main').insertAdjacentHTML("beforeend", template);
                } else {
                    var template = '<li id="' + id + '"><div class="comment-main-level"><div class="comment-avatar"><img src="' + image + '" alt=""></div><div class="comment-box"><div class="comment-head"><h6 class="comment-name"><a href="#">' + name + '</a></h6><span class="posted-time">Posted on ' + date + '</span></div><div class="comment-content">' + message + '<div class="comment-open"><a class="btn-reply">Reply</a></div></div><div class="comment-footer"><div class="comment-form"><textarea class="form-control" name=""></textarea><div class="pull-right send-button"><a class="btn-send send-reply">Send</a></div></div></div></div></div><ul class="comments-list queries reply-list"></ul></li>';
                    document.getElementById('queries-list').insertAdjacentHTML("beforeend", template);
                }
            },
            showReply(id, parent, name, message, date, image) {
                var template = '<li id="' + id + '"><div class="comment-avatar"><img src="' + image + '"></div> <div class="comment-box"> <div class="comment-head"><h6 class="comment-name"><a href="javascript:;">' + name + '</a></h6> <span class="posted-time">Posted on ' + date + '</span> </div> <div class="comment-content"> ' + message + '</div> </div> </li>';
                document.getElementById(parent).childNodes[1].insertAdjacentHTML("beforeend", template);
            },
            showNotes(id, name, file) {
                var template = '<li id="' + id + '"><a href="' + file + '" target="_blank" download>' + name + '</a></li>';
                document.getElementById('notes-list').insertAdjacentHTML("beforeend", template);
            },
            getComments() {
                var t = this;
                var url = this.$store.getters.getDomain;

                var data = {class_id: t.classId}
                axios.post(`${url}api/v2/classes/get-student-comment`, data, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        if (response['data']['response']['comments'].length) {
                            t.commentsList = response['data']['response']['comments'];
                            t.initializeEvents();
                        }
                    }
                });
            },
            uniqueId() {
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < 15; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return this.$store.getters.getUser['user_id'] + result;
            },
            initializeEvents() {
                var t = this;
                $(document).on('click', '.btn-reply', function (eve) {
                    eve.preventDefault();
                    $(this).parent().parent().siblings('.comment-footer').slideToggle();
                    eve.stopImmediatePropagation();
                });
                $(document).on('click', '.send-reply', function (eve) {
                    eve.preventDefault();
                    var targetObject = $(this).parent().parent().parent().parent().parent();
                    var textarea = $(this).parent().siblings('textarea');
                    var reply_text = $(this).parent().siblings('textarea').val();

                    if ($.trim(reply_text) == " " || $.trim(reply_text) == "") {
                        alert("insert comment");
                    } else {
                        if ($(targetObject).hasClass("comment-main-level")) {
                            if ($(targetObject).siblings('.comments-list.queries.reply-list')) {
                                // var element_prepend = '<li><div class="comment-avatar"><img alt="" src="http://dummyimage.com/60"></div><div class="comment-box"> <div class="comment-head"> <h6 class="comment-name"><a href="#">You</a></h6> <span class="posted-time">Posted on DD-MM-YYYY HH:MM</span></div><div class="comment-content">'+ reply_text +'</div></div></li>';
                                // $(targetObject).siblings('.comments-list.reply-list').prepend(element_prepend);
                                var r_id = $(targetObject).parent('li').attr('id');
                                textarea.val('');
                                t.sendReply(reply_text, r_id);
                            }
                        }
                    }
                });
            },
        }
    }
</script>
<style>
    ul {
        list-style-type: none;
    }

    .comments-list {
        position: relative;
        padding: 0px 15px;
    }

    #notes-list {
        border: 1px solid #ddd;
    }

    #notes-list li:first-child {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
    }

    #notes-list li {
        padding: 10px;
        border-bottom: 1px solid #ddd;
    }

    #notes-list li a {
        word-break: break-all;
    }

    #notes-list li:last-child {
        border-bottom: 0px;
    }

    #queries-list, #comments-list-main {
        padding-top: 30px;
    }

    #queries-list > li:before, #comments-list-main > li:before {
        content: '';
        width: 2px;
        height: 100%;
        background: #c7cacb;
        position: absolute;
        left: 31px;
        top: 0;
    }

    .reply-list:before, .reply-list:after {
        display: none;
    }

    .reply-list li:before {
        content: '';
        width: 55px;
        height: 2px;
        background: #c7cacb;
        position: absolute;
        top: 25px;
        left: -54px;
    }

    .comments-list li {
        padding-bottom: 15px;
        display: block;
        position: relative;
    }

    #quieries-list > li:last-child:after, #comments-list-main > li:last-child:after {
        content: '';
        position: absolute;
        background: #c7cacb;
        bottom: 0;
        left: 28.6px;
        width: 7px;
        height: 7px;
        border: 3px solid #dee1e3;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
    }

    .reply-list {
        padding-left: 85px;
        clear: both;
        margin-top: 15px;
    }

    .comments-list .comment-avatar {
        width: 65px;
        height: 65px;
        position: relative;
        z-index: 9;
        float: left;
        border: 3px solid #FFF;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        overflow: hidden;
    }

    .comments-list .comment-avatar img {
        width: 100%;
        height: 100%;
        background-color: #fff;
    }

    .reply-list .comment-avatar {
        width: 50px;
        height: 50px;
    }

    .comment-main-level:after {
        content: '';
        width: 0;
        height: 0;
        display: block;
        clear: both;
    }

    .comments-list .comment-box {
        width: calc(100% - 85px);
        float: right;
        position: relative;
        -webkit-box-shadow: 0 1px 10px 0px rgba(0, 0, 0, 0.15);
        -moz-box-shadow: 0 1px 10px 0px rgba(0, 0, 0, 0.15);
        box-shadow: 0 1px 10px 0px rgba(0, 0, 0, 0.15);
        background-color: #FFF;
    }

    .reply-list li .comment-box {
        float: none;
        display: inline-block;
        margin-left: 15px;
    }

    .comments-list .comment-box:before, .comments-list .comment-box:after {
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        display: block;
        border-width: 10px 12px 10px 0;
        border-style: solid;
        border-color: transparent #FCFCFC;
        top: 8px;
        left: -11px;
    }

    .comments-list .comment-box:before {
        border-width: 11px 13px 11px 0;
        border-color: transparent rgba(0, 0, 0, 0.05);
        left: -12px;
    }

    .reply-list .comment-box {
        width: calc(100% - 70px);
    }

    .comment-box .comment-head {
        background: #FCFCFC;
        padding: 10px 12px;
        border-bottom: 1px solid #E5E5E5;
        overflow: hidden;
        -webkit-border-radius: 4px 4px 0 0;
        -moz-border-radius: 4px 4px 0 0;
        border-radius: 4px 4px 0 0;
    }

    .comment-box .comment-head i {
        float: right;
        margin-left: 14px;
        position: relative;
        top: 2px;
        color: #A6A6A6;
        cursor: pointer;
        -webkit-transition: color 0.3s ease;
        -o-transition: color 0.3s ease;
        transition: color 0.3s ease;
    }

    .comment-box .comment-head i:hover {
        color: #00a0e3;
    }

    .comment-box .comment-name {
        color: #283035;
        font-size: 14px;
        font-weight: 700;
        float: left;
        margin-right: 10px;
    }

    .comment-box .comment-name a {
        color: #283035;
    }

    .comment-box .comment-head span {
        float: left;
        color: #999;
        font-size: 13px;
        position: relative;
        top: 1px;
    }

    .comment-box .comment-content {
        background: #FFF;
        padding: 12px;
        font-size: 15px;
        color: #595959;
        -webkit-border-radius: 0 0 0px 0px;
        -moz-border-radius: 0 0 0px 0px;
        border-radius: 0 0 0px 0px;
        border-bottom: .5px solid #e5e5e5;
    }

    .comment-box .comment-footer {
        border-radius: 0 0 4px 4px;
        padding: 12px;
        width: 100%;
        background: #fff none repeat scroll 0 0;
    }

    .comment-box .comment-footer textarea {
        resize: none;
        width: calc(100% - 100px);
        border-radius: 4px;
        padding: 1%;
        display: inline-block;
    }

    .comment-box .send-button, .comment-box .comment-open {
        padding: 12px;
        text-align: right;
        /*background: #fff none repeat scroll 0 0;*/
    }

    .send-button .btn-send, .comment-open .btn-send {
        background-color: #00a0e3;
        border-color: #00a0e3;
        color: #fff;
        padding: 6px 12px;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
    }

    .send-button .btn-send, .comment-open .btn-send {
        text-decoration: none;
    }

    .comment-box .btn-reply {
        cursor: pointer;
        text-align: right;
        background-color: #00a0e3;
        color: #fff;
        padding: 7px 15px;
    }

    .comment-box .comment-name.by-author, .comment-box .comment-name.by-author a {
        color: #00a0e3;
    }

    .comment-box .comment-name.by-author:after {
        /*content: '';*/
        background: #00a0e3;
        color: #FFF;
        font-size: 12px;
        padding: 3px 5px;
        font-weight: 700;
        margin-left: 10px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
    }

    .comment-box .posted-time {
        margin-top: 8px;
    }

    .comment-box .comment-footer {
        display: none;
    }

    .question-form {
        padding: 10px 15px;
    }

    .question-form textarea {
        width: calc(100% - 80px);
        display: inline-block;
    }

    .question-form div.send-button {
        margin-top: 10px;
    }

    #queries-list, #comments-list-main {
        max-height: 500px;
        overflow: hidden;
    }

    #queries-list .ps-scrollbar-x-rail, #comments-list-main .ps-scrollbar-x-rail {
        display: none !important;
    }
</style>